/**
 * Create route for learn-quiz page.
 */
export const learnQuizRoute = ({
  pageName,
  quizTag,
  quizType,
  resume,
}: {
  pageName: string[] | string;
  quizTag: string;
  quizType: string;
  resume?: boolean;
}) =>
  `/learn-quiz/${pageName}/${quizTag}/${quizType}${
    resume ? '?resume=true' : ''
  }`;
